import { Button, Modal, notification, Space, Switch, Table, Typography, Card } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, CheckOutlined, CloseOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ajaxService from '../../services/ajax-services';
import { useWindowSize } from '../../hooks';

const { Title, Text } = Typography

function Accounts() {

    const { width } = useWindowSize()

    const isMobile = width <= 768
    const [dataSource, setDataSource] = useState([])
    const [showModal, setShowModal] = useState(false)
    let history = useHistory()

    const updateValue = async (id, val, type) => {
        const active = await ajaxService.put('accounts/', { type: type, value: val }, id)
        if (active) {
            if (val === true) {
                notification.open({ message: 'Account activated', icon: <CheckCircleOutlined style={{ color: '#108ee9' }} /> })
            } else if (val === false) {
                notification.open({ message: 'Account deactivated', icon: <CheckCircleOutlined style={{ color: '#108ee9' }} /> })
            }
        }
        else {
            notification.open({ message: 'Unable to update active', icon: <CloseCircleOutlined style={{ color: 'red' }} /> })
        }
    }

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'title',
            width: '75%',
        },
        {
            title: 'Active',
            dataIndex: 'active',
            key: 'active',
            render: (text, record) => {
                return (<Switch
                    onChange={(val) => updateValue(record.id, val, 'active')}
                    checkedChildren={<CheckOutlined />}
                    unCheckedChildren={<CloseOutlined />}
                    defaultChecked={record.active == 1 ? true : false} />)
            }
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record) => {
                return (
                    <Space size='small'>
                        <Button type='primary' onClick={() => history.push({ pathname: '/accounts/form/' + record.id })}>Edit</Button>
                        <Button type='primary' danger onClick={() => openDeleteModal(record.id)}>Delete</Button>
                    </Space>)
            }
        },
    ]

    const deleteRow = async () => {
        let account_id = localStorage.getItem('account')

        let values = {
            is_delete: 1
        }
        let item = await ajaxService.put('accounts/', values, account_id)
        if (item) {
            initialize()
            setShowModal(false)
            notification.open({ message: 'Account has been deleted successfully', icon: <CheckCircleOutlined style={{ color: '#108ee9' }} /> })
        }
    }

    const openDeleteModal = (id) => {
        localStorage.setItem('account', id);
        setShowModal(true)
    }

    const initialize = async () => {
        setDataSource([])
        let data = await ajaxService.get('accounts')
        if (data) {
            setDataSource(data)
        }
    }

    useEffect(() => {
        initialize()
    }, [])


    const renderHeader = () => {
        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Title level={3}>Accounts</Title>
                    <Space size="small" >
                        <Button className='addBtn' type="primary" shape="round"
                            onClick={() => history.push({ pathname: '/accounts/form/0' })}>Add Account</Button>
                    </Space>
                </div>
            </>
        )
    }


    const renderModal = () => {
        return (
            <Modal
                title="Delete Account"
                centered
                open={showModal}
                onCancel={() => setShowModal(false)}
                footer={[
                    <Button type='primary' danger key="delete" onClick={() => deleteRow()}>
                        Delete
                    </Button>,
                    <Button key="back" onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                ]}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <p>Are you sure you want to delete this account?</p>
                </div>
            </Modal>
        )
    }

    const renderAccounts = () => {

        return (
            <>
                <Table
                    dataSource={dataSource}
                    columns={columns}
                    title={() => renderHeader()}
                />

            </>
        );
    }

    const renderAccountsMobile = () => {
        return (
            <>
                {
                    dataSource.map(account => {
                        return (
                            <>
                                <br />
                                <Card
                                    style={{ width: 330 }}
                                    actions={[
                                        <Space size='small'>
                                            <Button type='primary' icon={<EditOutlined />} onClick={() => history.push({ pathname: '/accounts/form/' + account.id })}>Edit</Button>
                                            <Button type='primary' danger icon={<DeleteOutlined />} onClick={() => openDeleteModal(account.id)}>Delete</Button>
                                        </Space>
                                    ]}>
                                    <Text style={{ fontWeight: 'bolder' }}>Name : <span style={{ fontWeight: 'lighter', marginLeft: 10 }}>{account.name}</span></Text>
                                    <br /><br />
                                    <Text style={{ fontWeight: 'bolder' }}>Active :
                                        <span style={{ fontWeight: 'lighter', marginLeft: 10 }}>
                                            <Switch
                                                onChange={(val) => updateValue(account.id, val, 'active')}
                                                checkedChildren={<CheckOutlined />}
                                                unCheckedChildren={<CloseOutlined />}
                                                defaultChecked={account.active == 1 ? true : false}
                                            />
                                        </span>
                                    </Text>
                                    <br />
                                </Card>
                                <br />
                            </>
                        );
                    })
                }
            </>
        )
    }

    const renderContent = () => {
        if (isMobile) {
            return renderAccountsMobile()
        } else {
            return renderAccounts()
        }
    }

    return (
        <>
            {isMobile && renderHeader()}
            {renderContent()}
            {renderModal()}
        </>
    )
}

export default Accounts